import { Component, Input, OnInit, SimpleChanges, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'ers-embedded-power-app',
    templateUrl: './embedded-power-app.component.html',
    styleUrls: ['./embedded-power-app.component.scss'],
    standalone: false
})
export class EmbeddedPowerAppComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);

  @Input() powerAppId: string | undefined;
  @Input() powerAppTitle: string | undefined;
  powerAppLink: SafeResourceUrl | undefined;

  ngOnInit(): void {
    if (!this.powerAppId) {
      throw new Error('PowerApp ID is required');
    }
    if (!this.powerAppTitle) {
      throw new Error('PowerApp Title is required');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['powerAppId'] && this.powerAppId) {
      // Only update the powerAppLink if powerAppId changes
      this.powerAppLink = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://apps.powerapps.com/play/${this.powerAppId}`,
      );
    } else {
      this.powerAppLink = undefined;
    }
  }
}
